import { useNavigate, useSearch } from '@tanstack/react-router';
import { useCallback, useMemo } from 'react';

import { useStore } from '@/shared/store/store-context';

import { resolveRange, todayIn, type RangeSearch } from '../schemas/report-range';

const LAYOUT_ID = '/_authed/_active/s/$storeId/reports' as const;

/** The range every reports tab shares, read from and written to the URL. */
export function useReportRange() {
  const store = useStore();
  const { range: preset, from, to } = useSearch({ from: LAYOUT_ID });
  const navigate = useNavigate();
  const today = todayIn(store.timezone);
  const range = useMemo(
    () => resolveRange({ range: preset, from, to }, today),
    [preset, from, to, today],
  );
  const setRange = useCallback(
    (next: RangeSearch) =>
      void navigate({
        to: '.',
        search: (prev) => ({ ...prev, range: next.range, from: next.from, to: next.to }),
      }),
    [navigate],
  );
  return { range, today, setRange };
}
